import { UploadBulkFiles } from "@/api/bulkFileUpload/model/bulkFileUploadModel"

export interface UploadResultCount {
  successed: number
  failed: number
}

export enum UploadProgressStatus {
  INIT = 'init',
  IN_PROGRESS = 'inProgress',
  PAUSE = 'pause',
  DISCONTINUE = 'discontinue',
  FINISH = 'finish',
}

export interface State {
  //ファイルアップロード
  modalBulkFileUploadActived: boolean
  // アップロード中止するダイアログ画面
  modalDiscontinueUploadActived: boolean
  //true:アップロード中　false:中止した
  uploadProgressStatus: UploadProgressStatus
  //アップロードするファイル合計件数
  totalCount: number
  //アップロード中の位置
  currentCount: number
  //アップロード結果件数
  uploadResultCount: UploadResultCount
  //file check error
  fileCheckError: string
  //ファイルデータ
  uploadFiles: UploadBulkFiles
}

const state = (): State => ({
  modalBulkFileUploadActived: false,
  modalDiscontinueUploadActived: false,
  uploadProgressStatus: UploadProgressStatus.INIT,
  totalCount: 0,
  currentCount: 0,
  uploadResultCount: {
    successed: 0,
    failed: 0,
  },
  fileCheckError: '',
  uploadFiles: [] as UploadBulkFiles,
})

export default state
